// Canvas and UI constants
export const CANVAS_SIZE = 5000;
export const NODE_RADIUS = 60; // legacy fallback
export const NODE_W = 160;
export const NODE_H = 52;
export const NODE_W_ROOT = 192;
export const NODE_H_ROOT = 64;
export const NODE_RX = 12;
export const DRAG_THRESHOLD = 10;

// Zoom constants
export const ZOOM_MIN = 0.2;
export const ZOOM_MAX = 3;
export const ZOOM_FACTOR = 1.1;

// Selection colors
export const SELECTION_COLORS = {
  MOVEMENT: THEME.selection,
  ADD_CHILD: THEME.warning
};

// Node types
export const NODE_TYPES = {
  PROBLEM: 'problem',
  SOLUTION: 'solution'
};

// Import theme
import { THEME, COLOR_PICKER_PALETTE } from './theme';

// Default colors (using Catppuccin Latte theme)
export const DEFAULT_COLORS = {
  PROBLEM: THEME.node.problem,
  SOLUTION: THEME.node.solution,
  PROBLEM_FILL: THEME.node.problemFill,
  SOLUTION_FILL: THEME.node.solutionFill,
  PROBLEM_TEXT: THEME.node.problemText,
  SOLUTION_TEXT: THEME.node.solutionText,
  BANNED_FILL: THEME.node.banned,
  BANNED_STROKE: THEME.node.bannedStroke,
  BANNED_TEXT: THEME.node.bannedText
};

// Color palette for color picker
export const COLOR_PALETTE = COLOR_PICKER_PALETTE;

// AI configuration
export const AI_CONFIG = {
  MODEL: 'claude-sonnet-4-5',
  MAX_TOKENS: 1024,
  RETRY_COUNT: 3,
  RETRY_DELAY_BASE: 1000
};

// Grid settings
export const GRID_SIZE = 40;
export const GRID_COLOR = THEME.canvas.grid;
export const GRID_LINE_WIDTH = 0.5;

// Connection settings
export const CONNECTION = {
  COLOR: THEME.canvas.connection,
  WIDTH: 2,
  OPACITY: 0.75,
  BANNED_OPACITY: 0.2,
  // Legacy — used by export.js and SharedMapView (not by ConnectionItem)
  DASH_ARRAY: '8,6',
  ARROW_SIZE: 10,
  ARROW_ANGLE: Math.PI / 6
};

// Positioning settings
export const POSITIONING = {
  PROBLEM_SPACING: 300,
  SOLUTION_RADIUS: 180,
  CHILD_RADIUS: 150,
  START_ANGLE: -Math.PI / 2,
  ANGLE_STEP: Math.PI / 4
};

// Export settings
export const EXPORT = {
  PNG_SCALE: 2,
  MERMAID_PREFIX: 'graph TD\n'
};

// Problem intent keywords
export const PROBLEM_KEYWORDS = [
  'problema:',
  'problema ',
  'nuovo problema',
  'problem:',
  'problem '
];

// Storage settings
export const STORAGE = {
  MAPS_INDEX: 'brainstormer_maps_index',
  MAP_PREFIX: 'brainstormer_map_',
  SETTINGS: 'brainstormer_settings',
  VERSION: 1,
  AUTOSAVE_DEBOUNCE_MS: 500,
  DEFAULT_MAP_NAME: 'New Map'
};

// Info Gathering settings
export const INFO_GATHERING = {
  MAX_QUESTIONS: 3,
  STOP_KEYWORDS: ['basta', 'stop', 'ok così', 'ok cosi', 'procedi', 'fine', 'ok', 'enough', 'proceed', 'continue', 'done', 'got it'],
  PROBLEM_FOCUS: ['contesto', 'impatto', 'vincoli', 'obiettivo', 'stakeholder'],
  SOLUTION_FOCUS: ['implementazione', 'risorse', 'tempistiche', 'ostacoli', 'prerequisiti']
};
